<template>
  <el-main>
    <div class="formSubmitBtnBox">
      <el-button style="margin: 10px;" @click="getAllCertExpiryUser()">證照複訓</el-button>

      <el-button style="margin: 10px;" @click="UserInfoAddOne()">新增會員</el-button>
      <el-dropdown @command="handleCommand">
        <el-button>匯入匯出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="import">匯入會員</el-dropdown-item>
          <el-dropdown-item command="photo">匯入證照照片</el-dropdown-item>
          <el-dropdown-item command="export">匯出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <br />
    <el-row>
      <el-col :span="12"><el-button icon="el-icon-delete-solid" style="margin:0 12px 0 0" @click="DeleteUserInfo()"></el-button><span> 選擇並刪除</span></el-col>
      <el-col :span="12" align="right"><i class="el-icon-search"></i><el-input style="width:200px; margin:0 15px" v-model="search" placeholder="搜尋姓名 or 證照日期"/></el-col>
    </el-row>

    <br />
    <!-- ||data.c_Date.substring(0,10).replace(/-/g,'/') === search -->
    <el-table
      v-loading="loading"
      :data="
        userInfoList
          .filter((data) => !search || data.name.match(search) || data.phone.match(search) || data.tR_Date.match(search) || (data.c_Number === null ? '' : data.c_Number).match(search))
          .slice((currentPage - 1) * pagesize, currentPage * pagesize)
      "
      style="width: 100%"
      height="550"
      header-row-class-name="center"
      @selection-change="handleSelectionChange"
      :default-sort="{
        prop: 'userId,tR_Date,tR_Status,c_Date,c_Number',
        order: 'descending',
      }"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column label="" fixed width="1"> </el-table-column>
      <el-table-column label="姓名" fixed width="70">
        <template slot-scope="scope">
          <ele-image fit="contain" :size="60" radius="50%" :username="scope.row.name" :src="scope.row.photoUrl" :preview-src-list="[scope.row.photoUrl]"></ele-image>
        </template>
      </el-table-column>
      <el-table-column label="" fixed width="80">
        <template slot-scope="scope">
          <el-button class="btn2href" @click="Info(scope.row.userId)" style="text-decoration:none;">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="會員編號" width="150" prop="userId" sortable>
        <template slot-scope="scope">
          {{ scope.row.userId }}
        </template>
      </el-table-column>
      <el-table-column label="電話" width="150">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="生日" width="150">
        <template slot-scope="scope">
          {{ scope.row.birthday.substring(0, 10).replace(/-/g, '/') }}
        </template>
      </el-table-column>

      <el-table-column label="培訓日期" width="150" prop="tR_Date" sortable>
        <template slot-scope="scope">
          {{ scope.row.tR_Date }}
        </template>
      </el-table-column>
      <el-table-column label="培訓狀態" width="100" prop="tR_Status" sortable>
        <template slot-scope="scope">
          <div :class="scope.row.tR_Status ? 'tr-status-true' : 'tr-status-false'">
            <p v-if="scope.row.tR_Status">有效</p>
            <p v-else style="color: #F56C6C;">無效</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="證照日期" width="150" prop="c_Date" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.c_Number !== null">
            {{ scope.row.c_Date.substring(0, 10).replace(/-/g, '/') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="證照效期" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.c_Number !== null" :style="scope.row.c_Status ? 'color:green;' : 'color:red'">
            {{ scope.row.c_Date.substring(0, 10).replace(/-/g, '/') }} ~
            {{ scope.row.c_Term.substring(0, 10).replace(/-/g, '/') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="證照號碼" width="150" prop="c_Number" sortable>
        <template slot-scope="scope">
          {{ scope.row.c_Number }}
        </template>
      </el-table-column>
      <el-table-column label="證照圖片" width="100">
        <template slot-scope="scope">
          <el-image fit="contain" :src="scope.row.c_PhotoUrl" :preview-src-list="[scope.row.c_PhotoUrl]"></el-image>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[100, 500, 1000, 5000, 1000, 50000]"
        :page-size="pagesize"
        layout="total, sizes,prev, pager, next"
        :total="
          userInfoList.filter((data) => !search || data.name.match(search) || data.phone.match(search) || data.tR_Date.match(search) || (data.c_Number === null ? '' : data.c_Number).match(search))
            .length
        "
        prev-text="上一頁"
        next-text="下一頁"
      >
      </el-pagination>
    </div>

    <!-- importDailog -->
    <el-dialog title="匯入會員" :visible.sync="importDailog" width="30%" :close-on-click-modal="false">
      <div class="dialog-info">
        <ol>
          <li style="padding:1.5px 0">
            <b>請先產生欲新增會員筆數之Excel，並下載Excel填入資料。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>會員資料填寫完畢後，選擇該Excel匯入。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>如中途遇筆數不足，請重新產生，不可自行在Excel新增會員。</b>
          </li>
        </ol>
      </div>
      <br />
      <div>
        <p>1.下載系統Excel</p>
        <el-form label-width="80px" @submit.native.prevent>
          <el-form-item label="新增會員">
            <el-row>
              <el-col :span="15"> <el-input class="input-div" placeholder="請輸入筆數" v-model="addNums" clearable></el-input></el-col>
              <el-col :span="9" align="right"> <el-button @click="generateExcel()">產生Excel</el-button></el-col>
            </el-row>
          </el-form-item>

          <el-button v-if="downloadBtn" @click="downloadExcel()" icon="el-icon-download" class="download-excel">下載Excel</el-button>
          <div>
            <hr style="margin:20px 0px" />

            <p>2.將系統Excel匯入</p>
            <el-form-item label="上傳" prop="attachmentFile">
              <AttachmentFileUploader :fileQuantityLimit="1" :fileList.sync="excelFile"></AttachmentFileUploader>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDailog = false">關閉</el-button>
      </div>
    </el-dialog>

    <!-- exportDailog -->
    <el-dialog title="匯出" :visible.sync="exportDailog" width="30%" :close-on-click-modal="false">
      <div class="dialog-info">
        <ol>
          <li style="padding:1.5px 0">
            <b>匯出之Excel再行匯入之後，皆會更改會員資料及 "第一筆" 培訓資料。</b>
          </li>
        </ol>
      </div>
      <br />
      <div class="export-div">
        <el-row class="export-div-inside">
          <el-col :span="12"><div>匯出選擇結果(施工中)</div></el-col>
          <el-col :span="12" align="right"><el-button type="primary">匯出</el-button></el-col>
        </el-row>
      </div>
      <br />
      <div class="export-div">
        <el-row class="export-div-inside">
          <el-col :span="12"><div>匯出全部</div></el-col>
          <el-col :span="12" align="right"><el-button type="primary" @click="exportAll()">匯出</el-button></el-col>
        </el-row>
      </div>
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDailog = false">關閉</el-button>
      </div>
    </el-dialog>

    <!-- excelConfirmDailog -->
    <el-dialog title="Excel確認" :visible.sync="repeatedDailog" width="70%" :close-on-click-modal="false">
      <div>
        Excel與現有會員資料發生重複，請選擇動作
      </div>
      <br />
      <el-table :data="repeatedList" style="width: 100%" height="550" header-row-class-name="center">
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <div :style="scope.row.nameRepeated ? 'color:red' : ''">
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="電話">
          <template slot-scope="scope">
            <div :style="scope.row.phoneRepeated ? 'color:red' : ''">
              {{ scope.row.phone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="說明">
          <template slot-scope="scope">
            系統已存在此{{ scope.row.nameRepeated ? '姓名' : '電話' }}
            <el-button @click="RepeatConfirm(scope.row, scope.$index)" type="text" size="small"> 查看</el-button>
            <div v-if="scope.row.targetUserId" style="color:#67C23A">已選擇：{{ scope.row.targetUserId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="是否為同一人" width="450">
          <template slot-scope="scope">
            <el-button
              @click="UpdateTrainingRecored(scope.row, scope.$index)"
              :icon="actionBtnList[scope.$index].checked1 ? 'el-icon-check' : ''"
              :type="actionBtnList[scope.$index].loading1 || actionBtnList[scope.$index].checked1 ? 'success' : ''"
              :loading="actionBtnList[scope.$index].loading1"
              :disabled="actionBtnList[scope.$index].disable1"
              >是，更新培訓資料</el-button
            >
            <el-button
              @click="UpdateUserInfo(scope.row, scope.$index)"
              :icon="actionBtnList[scope.$index].checked2 ? 'el-icon-check' : ''"
              :type="actionBtnList[scope.$index].loading2 || actionBtnList[scope.$index].checked2 ? 'success' : ''"
              :loading="actionBtnList[scope.$index].loading2"
              :disabled="actionBtnList[scope.$index].disable2"
              >否，新增會員</el-button
            >
            <el-button @click="NotUpdate(scope.$index)" :disabled="actionBtnList[scope.$index].disable3">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--  -->
    <el-dialog title="重複資料" :visible.sync="repeatCompareDailog" width="50%" :close-on-click-modal="false">
      <div>若為同一人，請選擇要加入培訓紀錄的會員，再按「是，更新培訓資料」</div>
      <br />
      <el-table :data="repeatCompare" style="width: 100%" max-height="400" header-row-class-name="center">
        <el-table-column label="資料來源">
          <template slot-scope="scope">
            {{ scope.$index == 0 ? '從Excel匯入' : '從資料庫' }}
          </template>
        </el-table-column>
        <el-table-column label="會員編號">
          <template slot-scope="scope">
            {{ scope.row.userId }}
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <div :style="scope.row.nameRepeated ? 'color:red' : ''">
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="電話">
          <template slot-scope="scope">
            <div :style="scope.row.phoneRepeated ? 'color:red' : ''">
              {{ scope.row.phone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="生日">
          <template slot-scope="scope">
            {{ scope.row.birthday }}
          </template>
        </el-table-column>
        <el-table-column label="同一人" width="110">
          <template slot-scope="scope">
            <el-button
              v-if="scope.$index > 0"
              @click="SelectTargetUser(scope.row.userId)"
              :type="IsTargetUser(scope.row.userId) ? 'success' : ''"
              :icon="IsTargetUser(scope.row.userId) ? 'el-icon-check' : ''"
              size="small"
              >{{ IsTargetUser(scope.row.userId) ? '已選擇' : '選擇' }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- importDailog -->
    <el-dialog title="匯入大量證照" :visible.sync="photoDailog" width="30%" :close-on-click-modal="false">
      <div class="dialog-info">
        <div style="margin:5px">中華兩岸勞資法務顧問協會</div>
        <ol style="margin:0px">
          <li style="padding:1.5px 0">
            <b>範例檔名證照編號 : KF202104000011-王素樺</b>
          </li>
          <li style="padding:1.5px 0">
            <b>請使用範例檔名，將對應的證照圖片重新命名。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>選擇需上傳的圖片檔案(可大量選取，單次最多50張)。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>開始匯入。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>如需修改照片，請再次匯入即可。</b>
          </li>
        </ol>
      </div>
      <br />
      <div class="dialog-info">
        <div style="margin:5px">中華民國全國工業總會</div>
        <ol style="margin:0px">
          <li style="padding:1.5px 0">
            <b>範例檔名證照編號 : 202104000011-王素樺</b>
          </li>
          <li style="padding:1.5px 0">
            <b>請使用範例檔名，將對應的證照圖片重新命名。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>選擇需上傳的圖片檔案(可大量選取，單次最多50張)。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>開始匯入。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>如需修改照片，請再次匯入即可。</b>
          </li>
        </ol>
      </div>
      <br />
      <div>
        <el-form label-width="80px" @submit.native.prevent>
          <div>
            <div style="margin:15px 0">上傳</div>
            <PictureUploader :fileQuantityLimit="50" :fileList.sync="photoFile"></PictureUploader>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="photoDailog = false">關閉</el-button>
      </div>
    </el-dialog>

    <template>
      <el-dialog title="證照需複訓名單" :visible.sync="certRetrainDialog" width="50%">
        <div style="margin-bottom: 16px;">以今日起算，證照效期失效、效期不滿4個月名單。</div>
        <div class="scrollable-table-container">
          <table class="scrollable-table" border="1">
            <thead>
              <tr>
                <th>姓名</th>
                <th>電話</th>
                <th>證照起始日</th>
                <th>信箱</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="x in certExpiryList" :key="x.userId">
                <td>{{ x.name }}</td>
                <td>{{ x.phone }}</td>
                <td>{{ formatDate(x.certificateDate) }}</td>
                <td>{{ x.email }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="copyTableToClipboard">複製表格</el-button>
          <el-button type="primary" @click="sendCertExpiryMail" :loading="sendMailLoading">寄信</el-button>
          <el-button @click="certRetrainDialog = false">關閉</el-button>
        </span>
      </el-dialog>
    </template>
  </el-main>
</template>

<script>
import {
  C_UserInfo_UTRCList,
  C_UserInfo_Excel,
  C_UserInfo_ExportUrl,
  C_UserInfo_Import,
  C_UserInfo_Repeat,
  C_UserInfo_AddTR,
  C_UserInfo_UpdateUI,
  C_Certificate_PhotoImport,
  C_UserInfo_AddOne,
  C_UserInfo_DeleteList,
  C_UserInfo_GetAllCertExpiryUser,
  C_UserInfo_SendCertExpiryMail,
} from '@/assets/js/api';

import PictureUploader from '@/components/PictureUploader.vue';
import AttachmentFileUploader from '@/components/AttachmentFileUploader.vue';

export default {
  data() {
    return {
      certRetrainDialog: false,
      certExpiryList: [],
      sendMailLoading: false,
      actionBtnList: [
        {
          actionIndex: 0,
          loading1: false,
          disable1: false,
          checked1: false,
          loading2: false,
          disable2: false,
          checked2: false,
          disable3: false,
        },
        {
          actionIndex: 1,
          loading1: false,
          disable1: false,
          checked1: false,
          loading2: false,
          disable2: false,
          checked2: false,
          disable3: false,
        },
      ],
      currentPage: 1, // 默認顯示第一頁
      pagesize: 100, //    每頁顯示筆數
      selectedItem: 0,
      downloadBtn: false,
      importDailog: false,
      exportDailog: false,
      photoDailog: false,
      repeatedDailog: false,
      repeatCompareDailog: false,
      repeatCompareIndex: -1, // 「重複資料」視窗對應 repeatedList 的哪一列
      search: '',
      submitDialog: false,
      excelFile: [],
      photoFile: [],
      multipleSelection: [],
      repeatCompare: [
        {
          userId: 'kf001',
          name: '金小豐',
          phone: '0987654321',
          birthday: '2021/01/01',
        },
        {
          userId: 'kf002',
          name: '董峰如',
          phone: '0912345678',
          birthday: '2021/09/09',
        },
      ],
      addNums: 0,
      userInfoList: [],
      repeatedList: [
        {
          userId: 'kf001',
          name: '金小豐',
          nameRepeated: false,
          phone: '0987654321',
          phoneRepeated: true,
          birthday: '2021/01/01',
          host: '金豐企業大學',
          date: '2021/02/04',
          lecturerName: '董峰如',
          hours: '5',
        },
        {
          userId: 'kf002',
          name: '董峰如',
          nameRepeated: true,
          phone: '0912345678',
          phoneRepeated: false,
          birthday: '2021/09/09',
          host: '金豐企業大學校長',
          date: '2021/09/08',
          lecturerName: '董峰如',
          hours: '12',
        },
      ],
      loading: true,
    };
  },
  components: {
    PictureUploader,
    AttachmentFileUploader,
  },

  mounted() {
    this.getUserInfo();
  },
  watch: {
    importDailog() {
      if (this.importDailog === true) {
        this.downloadBtn = false;
        this.addNums = '';
        this.excelFile = [];
      } else {
        this.getUserInfo();
      }
    },
    photoDailog() {
      if (this.photoDailog === true) {
        this.photoFile = [];
      }
    },
    excelFile() {
      if (this.excelFile[0].raw !== null || this.excelFile[0].raw !== '') {
        if (this.excelFile[0].name.slice(-4) !== 'xlsx') {
          this.$message.error('檔案格式不符，請重新上傳');
          this.excelFile = [];
        } else {
          const formData = new FormData();
          formData.append('file', this.excelFile[0].raw);
          C_UserInfo_Import(formData)
            .then((res) => {
              console.log(res.data.data.item2);
              this.repeatedList = res.data.data.item2;
              this.$notify({
                title: '成功',
                message: res.data.data.item1,
                type: 'success',
              });
              if (res.data.data.item2.length > 0) {
                this.repeatedDailog = true;
              }
              this.SetActionBtn();
              this.getUserInfo();
            })
            .catch((err) => {
              this.$notify({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        }
      }
    },

    photoFile() {
      if (this.photoFile.length > 0) {
        console.log(this.photoFile[0].raw);
        const photoInportList = [];
        this.photoFile.forEach((x) => {
          photoInportList.push(x.raw);
        });
        console.log(photoInportList);
        const formData = new FormData();
        this.photoFile.forEach((x) => {
          formData.append('formFilesList', x.raw);
          // photoInportList.push(x.raw);
        });
        // formData.append('formFilesList', photoInportList);
        C_Certificate_PhotoImport(formData)
          .then((res) => {
            this.$notify({
              title: '成功',
              message: res.data.data.message,
              type: 'success',
            });
            this.photoDailog = false;
            this.getUserInfo();
          })
          .catch((err) => {
            this.$notify({
              title: '失敗',
              message: err.response.data.data.message,
              type: 'error',
            });
          });
      }
    },
    repeatedList() {
      if (this.repeatedList.length < 1) {
        setTimeout(() => {
          this.repeatedDailog = false;
        }, 300);
      }
    },
  },
  methods: {
    SetActionBtn() {
      this.repeatedList.forEach((x, index) => {
        this.actionBtnList.push({
          actionIndex: index,
          loading1: false,
          disable1: false,
          checked1: false,
          loading2: false,
          disable2: false,
          checked2: false,
          disable3: false,
        });
      });
      console.log(this.actionBtnList);
    },
    RepeatConfirm(data, index) {
      C_UserInfo_Repeat(data)
        .then((res) => {
          console.log(res.data.data);
          this.repeatCompare = res.data.data;
          this.repeatCompareIndex = index;
          this.repeatCompareDailog = true;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.response.data.message,
          });
        });
    },
    // 姓名或電話相同的會員可能不只一位，指定要加入培訓紀錄的會員
    SelectTargetUser(userId) {
      this.$set(this.repeatedList[this.repeatCompareIndex], 'targetUserId', userId);
      this.repeatCompareDailog = false;
    },
    IsTargetUser(userId) {
      const row = this.repeatedList[this.repeatCompareIndex];
      return row !== undefined && row.targetUserId === userId;
    },
    UpdateTrainingRecored(data, index) {
      this.actionBtnList[index].loading1 = true;
      this.actionBtnList[index].disable2 = true;
      this.actionBtnList[index].disable3 = true;
      C_UserInfo_AddTR(data)
        .then((res) => {
          console.log(res.data);
          const success = res.data.message === '更新培訓資料成功';
          this.$message({
            type: success ? 'success' : 'error',
            message: res.data.message,
          });
          if (success) this.FinishAction(index, 1);
          else this.ResetActionBtn(index);
        })
        .catch((err) => {
          this.ResetActionBtn(index);
          this.$message({
            type: 'error',
            message: err.response.data.message,
          });
        });
    },
    UpdateUserInfo(data, index) {
      this.actionBtnList[index].loading2 = true;
      this.actionBtnList[index].disable1 = true;
      this.actionBtnList[index].disable3 = true;
      C_UserInfo_UpdateUI(data)
        .then((res) => {
          const success = res.data.message === '新增會員成功';
          this.$message({
            type: success ? 'success' : 'error',
            message: res.data.message,
          });
          if (success) this.FinishAction(index, 2);
          else this.ResetActionBtn(index);
        })
        .catch((err) => {
          this.ResetActionBtn(index);
          this.$message({
            type: 'error',
            message: err.response.data.message,
          });
        });
    },
    // 成功：按鈕打勾後把這一列移出清單
    FinishAction(index, btn) {
      setTimeout(() => {
        this.actionBtnList[index][`checked${btn}`] = true;
        this.actionBtnList[index][`loading${btn}`] = false;
        this.actionBtnList[index][`disable${btn}`] = true;
      }, 750);
      setTimeout(() => {
        this.ResetActionBtn(index);
        this.repeatedList.splice(index, 1);
      }, 1500);
    },
    // 失敗：按鈕恢復，資料留在清單上讓人重新處理
    ResetActionBtn(index) {
      Object.assign(this.actionBtnList[index], {
        loading1: false,
        disable1: false,
        checked1: false,
        loading2: false,
        disable2: false,
        checked2: false,
        disable3: false,
      });
    },
    NotUpdate(index) {
      this.repeatedList.splice(index, 1);
    },

    handleSizeChange(size) {
      this.pagesize = size;
      /* console.log(this.pagesize) */
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      /* console.log(this.currentPage) */
    },

    exportAll() {
      C_UserInfo_Excel(0)
        .then(() => {
          // 下載excel
          window.open(C_UserInfo_ExportUrl + 0);
          this.$notify({
            title: '下載成功',
            message: '已下載全部會員Excel',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            message: err.response.data.message,
            type: 'warning',
          });
        });
    },
    generateExcel() {
      if (this.addNums > 0) {
        this.downloadBtn = true;
      } else {
        this.$message.error('請輸入大於 0 的數');
      }
    },
    downloadExcel() {
      C_UserInfo_Excel(this.addNums)
        .then((res) => {
          // 下載excel
          window.open(C_UserInfo_ExportUrl + this.addNums);
          this.$notify({
            title: '下載成功',
            message: res.data.data.message,
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            message: err.response.data.message,
            type: 'warning',
          });
        });
    },
    handleCommand(command) {
      if (command === 'import') this.importDailog = true;
      if (command === 'export') this.exportDailog = true;
      if (command === 'photo') this.photoDailog = true;
    },
    getUserInfo() {
      C_UserInfo_UTRCList()
        .then((res) => {
          this.userInfoList = res.data.data.filter((x) => x.name !== null && x.phone != null);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 刪除 Dialog
    DeleteUserInfo() {
      if (this.multipleSelection.length < 1) {
        this.$confirm('請先選擇資料後再操作', '')
          .then(() => {})
          .catch(() => {});
      } else {
        this.$confirm(`確定刪除 ${this.multipleSelection.length} 筆資料嗎?  *(刪除後會員不會顯示在後台、也無法登入，培訓、考試、證照紀錄仍會保留)`, '刪除')
          .then(() => {
            this.UserInfoDeleteListAPI();
          })
          .catch(() => {});
      }
    },
    // 刪除API
    UserInfoDeleteListAPI() {
      const selectedIds = this.multipleSelection.map((x) => x.userId);
      const jsonObj = { MultUserId: selectedIds };
      C_UserInfo_DeleteList(jsonObj)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '刪除成功',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            title: '刪除失敗',
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.getUserInfo();
        });
    },
    // 新增會員
    UserInfoAddOne() {
      C_UserInfo_AddOne()
        .then((res) => {
          this.$notify({
            title: '成功',
            message: '新增成功，請自行修改個人資料及培訓紀錄',
            type: 'success',
          });
          this.$router.push({ path: `userInfo/${res.data.data.userId}` });
        })
        .catch((err) => {
          this.$notify({
            title: '新增失敗',
            message: err.response.data.message,
            type: 'error',
          });
        });
    },
    // submitExamInfoList() {
    //   this.submitDialog = false;
    //   C_ExamInfo_UpdateList()
    //     .then((res) => {
    //       this.$notify({
    //         title: '成功',
    //         message: '修改成功',
    //         type: 'success',
    //       });
    //       console.log(res.data.data.message);
    //     })
    //     .catch((err) => {
    //       console.log(err.response.data);
    //       this.$notify.error({
    //         title: '錯誤',
    //         message: '請確認欄位格式是否正確',
    //       });
    //     });
    // },
    Info(userId) {
      this.$router.push({ path: `userInfo/${userId} ` });
    },

    sendCertExpiryMail() {
      this.sendMailLoading = true;
      C_UserInfo_SendCertExpiryMail()
        .then((res) => {
          console.log(res);
          this.$message({
            message: '寄信完成! 請前往管顧信箱確認寄信結果',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$message({
            message: `寄信失敗，請重試: ${err}`,
            type: 'error',
          });
        })
        .finally(() => {
          this.sendMailLoading = false;
        });
    },

    getAllCertExpiryUser() {
      this.certRetrainDialog = true;
      C_UserInfo_GetAllCertExpiryUser()
        .then((res) => {
          console.log(res);
          this.certExpiryList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDate(date) {
      if (!date) return '';
      return date.split('T')[0]; // 將日期部分提取出來（yyyy-MM-dd）
    },
    copyTableToClipboard() {
      // 尋找表格元素
      const table = this.$el.querySelector('.scrollable-table');
      let tableText = '';

      // 獲取表頭
      const headers = table.querySelectorAll('th');
      headers.forEach((header, index) => {
        tableText += header.innerText + (index < headers.length - 1 ? '\t' : '\n');
      });

      // 獲取表格內容
      const rows = table.querySelectorAll('tbody tr');
      rows.forEach((row) => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, index) => {
          let cellText = cell.innerText;

          // 如果是電話欄位，添加單引號前綴以保留前導零
          if (index === 1 && cellText.startsWith('0')) {
            // 假設第 2 列是電話
            cellText = `'${cellText}`;
          }

          tableText += cellText + (index < cells.length - 1 ? '\t' : '\n');
        });
      });

      // 將文本放入剪貼簿
      navigator.clipboard
        .writeText(tableText)
        .then(() => {
          this.$message({
            message: '表格數據已成功複製到剪貼簿，可以直接貼上到 Excel 中',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$message({
            message: `複製失敗，請重試: ${err}`,
            type: 'error',
          });
        });
    },
  },
};
</script>

<style lang="scss">
.tr-status-false {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;
  width: 48px;
  height: 32px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  box-sizing: border-box;
  border-radius: 4px;
}
.tr-status-true {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;
  width: 48px;
  height: 32px;
  background: #f4f4f5;
  border: 1px solid #e9e9eb;
  box-sizing: border-box;
  border-radius: 4px;
}

.dialog-info {
  background: #f5f7fa;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  padding: 3px;
}
.input-div {
  margin-right: 10px;
}
.download-excel {
  border: none;
  color: rgba(0, 0, 255, 0.849);
}
.user-img {
  border-radius: 50%;
}

.export-div {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.export-div-inside {
  align-items: center;
  display: flex;
  order: 1;
  margin: 16px 0px;
}
.pagination {
  margin: 10px 0 0 0;
  text-align: center;
}
.btn2href {
  padding: 0;
  border: none;
  color: rgba(38, 0, 255, 0.884);
}

.scrollable-table-container {
  max-height: 400px; /* 可以根據需要調整這個高度 */
  overflow-y: auto;
}

.scrollable-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.scrollable-table th {
  padding: 8px;
  border: 1px solid #ddd;
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
  z-index: 1; /* 確保表頭在滾動時位於最上層 */
}

.scrollable-table td {
  padding: 8px;
  border: 1px solid #ddd;
}
</style>
